/* ==========================================================================
   Funkissd — Sticky announcement bar
   The announcement bar ("Free Tracked Shipping Over $50") is its own theme
   section, separate from the sticky header, so by default it scrolls away
   immediately. This keeps it pinned above the sticky header instead by:
   1) making .utility-bar itself position: sticky (see the {% style %} block
      in sections/announcement-bar.liquid), and
   2) measuring its real rendered height and exposing it as a CSS variable
      so the header's own sticky offset (see sections/header.liquid) can
      sit directly below it instead of overlapping it.
   Re-measures on load and on resize so it stays correct if the bar wraps
   onto a second line on narrow screens.
   ========================================================================== */
(function () {
  function setHeight() {
    var bar = document.querySelector('.utility-bar');
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--funkissd-announcement-height', height + 'px');
  }

  function init() {
    setHeight();
    window.addEventListener('resize', setHeight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
